import {useCallback} from 'react';

import {getChartSplitLayoutId, getMainSplitLayoutId, ReportType} from './departmenttypes';

export const useResetDepartmentReportLayout = (onResetCompleted?: () => void) => {
  const resetLayout = useCallback(() => {
    Object.values(ReportType).forEach((reportType) => {
      localStorage.removeItem(getChartSplitLayoutId(reportType));
    });
    localStorage.removeItem(getMainSplitLayoutId());

    onResetCompleted?.();
  }, [onResetCompleted]);

  return {
    resetLayout,
  };
};
